"use strict";
/**
 *
 * Component: AppToolBar.tsx
 * Llenguatge: TypeScrypt
 * Autor: Jordi Riu
 * Versió: 1.1
 * Data: 05/04/2017
 * (c) Ajuntament de Manresa - abr 2017 - Departament de Sistemes d'Informació
 */

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var React = require("react");

var core_1 = require("@material-ui/core");

var mobx_react_1 = require("mobx-react");

var HelpOutline_1 = require("@material-ui/icons/HelpOutline");

var AppToolBar =
/** @class */
function (_super) {
  __extends(AppToolBar, _super);

  function AppToolBar(props) {
    var _this = _super.call(this, props) || this;

    _this.handleHelp = function () {
      _this.props.appState.pantState.goPantalla('/help');
    };

    if (_this.props.appState) {
      _this.props.appState.pantState.setHasToolBar();
    }

    return _this;
  }

  AppToolBar.prototype.render = function () {
    if (!this.props.appState) {
      return null;
    } // Separem els elements del children


    var elements = [];
    var defaultElements = [];
    var leftElements = [];
    var centerElements = [];
    var rightElements = [];
    var lastElements = [];

    if (this.props.children) {
      if (!(this.props.children instanceof Array)) {
        elements = [this.props.children];
      } else {
        elements = this.props.children;
      }

      elements.map(function (appToolBarElement) {
        if (appToolBarElement.props && appToolBarElement.props.alignment === 'left') {
          leftElements = leftElements.concat(appToolBarElement.props.children);
        } else if (appToolBarElement.props && appToolBarElement.props.alignment === 'center') {
          centerElements = centerElements.concat(appToolBarElement.props.children);
        } else if (appToolBarElement.props && appToolBarElement.props.alignment === 'right') {
          rightElements = rightElements.concat(appToolBarElement.props.children);
        } else if (appToolBarElement.props && appToolBarElement.props.alignment === 'last') {
          lastElements = lastElements.concat(appToolBarElement.props.children);
        } else {
          defaultElements.push(appToolBarElement);
        }
      });
    }

    var toolCss = {
      color: 'rgba(0,0,0,0.4)'
    };
    var label = this.props.label || this.props.appState.pantState.label;
    var help = !!this.props.appState.sessState.recurs.RECURLHELP;
    var icon = this.props.icon ? React.createElement(this.props.icon, {
      className: "App-toolbar-ico",
      style: toolCss
    }) : this.props.appState.pantState.pantallaActual.icon ? React.createElement(this.props.appState.pantState.pantallaActual.icon, {
      className: "App-toolbar-ico",
      style: toolCss
    }) : null;
    var helpButton = help && React.createElement(core_1.Tooltip, {
      title: "Ajuda"
    }, React.createElement(core_1.IconButton, {
      onClick: this.handleHelp
    }, React.createElement(HelpOutline_1.default, {
      style: toolCss
    })));
    var top = this.props.appState.pantState.marginHeader;
    var left = this.props.appState.menuState.marginDrawer;

    var myStyle = __assign({
      position: 'fixed',
      top: top,
      left: left,
      right: 0,
      minHeight: 40,
      backgroundColor: 'rgb(232, 232, 232)',
      zIndex: this.props.zIndex
    }, this.props.style);

    return React.createElement(core_1.Toolbar, {
      style: myStyle,
      className: this.props.className
    }, this.props.showIcon && icon, this.props.showLabel && React.createElement(core_1.Typography, {
      variant: "h6",
      noWrap: true,
      style: toolCss
    }, label), defaultElements, leftElements, this.props.separatedElements && React.createElement("div", {
      style: {
        flexGrow: 1
      }
    }), centerElements, React.createElement("div", {
      style: {
        flexGrow: 1
      }
    }), rightElements, this.props.showHelp && helpButton, lastElements);
  };

  AppToolBar.defaultProps = {
    showIcon: true,
    showLabel: true,
    showHelp: true,
    zIndex: 1
  };
  AppToolBar = __decorate([mobx_react_1.inject('appState'), mobx_react_1.observer], AppToolBar);
  return AppToolBar;
}(React.Component);

exports.default = AppToolBar;